import { useContext } from 'react';

import PersonContext from '@/pages/Person/PersonContext';
import CompleteChecklistItem from '@/pages/Profile/components/ChecklistSection/components/CompleteChecklistItem';
import IncompleteChecklistItem from '@/pages/Profile/components/ChecklistSection/components/IncompleteChecklistItem';
import Heading from '@/ui/components/Heading';

const ActiveMemberChecklist = () => {
  const { person } = useContext(PersonContext);

  const primaryCounselor = () => {
    return person?.staff_relationships.filter(
      (sr) => sr.relationship_type?.slug === 'primary-counselor'
    ).length >= 1 ? (
      <CompleteChecklistItem text="Primary Counselor" />
    ) : (
      <IncompleteChecklistItem text="No Primary Counselor" />
    );
  };

  return (
    <>
      <Heading value={3} text="Active Member" />

      <div>{primaryCounselor()}</div>
    </>
  );
};

export default ActiveMemberChecklist;
